import CarouselMain from "components/carouselMain/CarouselMain";

const Slides = () => {
  return (
    <div>
      <div class="relative bg-fixed">
        <div class="flex justify-center">
          <CarouselMain />
        </div>
      </div>
    </div>
  );
};

export default Slides;
